import React, { useState, useEffect,useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import TableAllData from "components/Content/CustomTable/TableAllData";

import { Box } from "@mui/material";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import AximDropdown from "components/Dropdown/AximDropdown";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";

function ExcessAllocation(props) {
    const { companyId, userInfo } = useContext(PrivateRoutesContext);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedYear, setSelectedYear] = useState("");
    const [excessAllocations, setExcessAllocations] = useState([]);
    const [excessTypesDictionary, setExcessTypesDictionary] = useState([]);
    const [years, setYears] = useState([]);
    const [excessTypes, setExcessTypes] = useState([]);
    const [selectedExcessType, setSelectedExcessType] = useState("");

    useEffect(() => {
        apiGet(apiUrls.getExcessAllocationTypes(companyId))
            .then((response) => {
                if (response.data) {
                    var groupedByYear = Utils.groupByArrays(response.data, 'year')
                        .sort().reverse();

                    if (groupedByYear && groupedByYear.length > 0 && groupedByYear[0] !== undefined)
                    {
                        var excessTypesDictionary = groupedByYear.map(y => { return { key: y.key, values: y.values.map(v => v.payoutTypeCode)} });
                        setExcessTypesDictionary(excessTypesDictionary);
                    }
                }
            })
            .catch((e) => {

            });
    }, [companyId]);

    const canDownload = useMemo(() => {
        return !Utils.isBroker(userInfo);
    },[userInfo]);

    useEffect(() => {
        setYears(excessTypesDictionary.map(v => v.key));
    },[excessTypesDictionary]);

    useEffect(() => {
        if (years && years.length > 0) {
            setSelectedYear(years[0]);
        }
    },[years])

    useEffect(() => {
        if (selectedYear) {
            var types = excessTypesDictionary.find(v => v.key === selectedYear).values;

            setExcessTypes(types);
        }
    },[selectedYear]);

    useEffect(() => {
        if (excessTypes && excessTypes.length > 0) {
            setSelectedExcessType(excessTypes[0]);
        }
    },[excessTypes])

    useEffect(() => {
        setIsLoading(true);

        if (selectedYear && selectedExcessType) {
            apiGet(apiUrls.getExcessAllocationDetails(companyId, selectedExcessType, selectedYear))
                .then((response) => {
                    setExcessAllocations(response.data);
                })
                .catch((e) => {
                  
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
        else {
            setIsLoading(false);
        }
    },[selectedYear, selectedExcessType])

    const handleChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleExcessType = (event) => {
        setSelectedExcessType(event.target.value);
    };

    const columns = [
        {
            Header: "Date",
            accessor: (cell) => Utils.formatDate(cell.periodName), // format date
            Cell: ({row}) => (
                <Box>
                    {Utils.formatDate(row.original.periodName)}
                </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Payout Amount",
            accessor: (cell) => 
                <Box className="text-end">
                    <CurrencyFormatter value={cell.actualPayoutAmount} /> 
                </Box>,
            className: 'text-end',
        },
        {
            Header: "Retro Amount",
            accessor: (cell) => 
                <Box className="text-end">
                    <CurrencyFormatter value={cell.retroAmount} /> 
                </Box>,
            className: 'text-end',
        },
        {
            Header: "Recoup Amount",
            accessor: (cell) => 
                <Box className="text-end">
                    <CurrencyFormatter value={cell.recoupAmount} /> 
                </Box>,
            className: 'text-end',
        },
        {
            Header: "Actual Payout Amount",
            accessor: (cell) => 
                <Box className="text-end">
                    <CurrencyFormatter value={cell.actualPayoutAmount} /> 
                </Box>,
            className: 'text-end',
        },
    ];

    return (
        <Box className={TableStyle.tableWrapper}>
            <Box className={"d-flex justify-content-flex-start align-items-center"}>
                <Box>
                    <AximDropdown
                        id="select-year"
                        label="Select Year"
                        handleChange={handleChange}
                        value={selectedYear}
                        pairs={years.map(item => ({ value: item }))} />
                </Box>
                <Box>
                    <AximDropdown
                        id="excess-type"
                        label="Select Excess Type"
                        handleChange={handleExcessType}
                        value={selectedExcessType}
                        pairs={excessTypes.map(item => ({ value: item }))} />
                </Box>
            </Box>
        
            <TableAllData
                columns={columns}
                data={excessAllocations ? excessAllocations : "No Data"}
                isLoading={isLoading}
                download={canDownload ? { prefix: "ExcessAllocation", table: "Excess Allocation" } : null}
            />
        </Box>
    );
}

export default ExcessAllocation;
